module.exports = __webpack_public_path__ + "img/cloud-bottom-left.231bfc9b.svg";